import { gql } from '@apollo/client';

export const DELETE_INSIGHT = gql`
  mutation deleteInsight($id: ID!) {
    insight: deleteInsight(id: $id) {
      id
      name
    }
  }
`;
